// faq-collapsible.liquid file
document.addEventListener('DOMContentLoaded', function () {
  const accordion = document.querySelector('.accordion');
  if (!accordion) return;

  const openFirst = accordion.dataset.openFirst === 'true';
  const headers = accordion.querySelectorAll('.accordion-header');

  headers.forEach((header, index) => {
    const content = header.nextElementSibling;

    // Open the first item if setting is true
    if (openFirst && index === 0) {
      header.classList.add('active');
      content.classList.add('show');
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    header.addEventListener('click', () => {
      const content = header.nextElementSibling;

      // Close others
      accordion.querySelectorAll('.accordion-content').forEach(other => {
        if (other !== content) {
          other.style.maxHeight = null;
          other.classList.remove('show');
          other.previousElementSibling.classList.remove('active');
        }
      });

      // Toggle clicked
      if (content.classList.contains('show')) {
        content.style.maxHeight = null;
        content.classList.remove('show');
        header.classList.remove('active');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('show');
        header.classList.add('active');
      }
    });
  });

  // Recalculate height on resize
  window.addEventListener('resize', () => {
    accordion.querySelectorAll('.accordion-content.show').forEach(content => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  });
});
